/** @module shop */

import { addToCart } from './molecules/add-to-cart/add-to-cart.js';
import { shoppingCartMini } from './molecules/shopping-cart-mini/_shopping-cart-mini.async.js';
import { checkoutButtonIndicator } from './atoms/checkout-button-indicator/checkout-button-indicator.js';
import { singleProduct } from './organisms/single-product.js';
import { variableProduct } from './organisms/variable-product.js';
import { productArchive } from '../templates/shop/product-archive.js';

/**
 * Initializes shop functionalities.
 *
 * @return {Promise<void>}
 */
export function shop() {
    return Promise.all([
        addToCart(),
        shoppingCartMini(),
        checkoutButtonIndicator(),
        singleProduct(),
        variableProduct(),
        productArchive(),
    ]);
}
